/* eslint-disable eqeqeq */
import React, { Component, Fragment } from "react";
import { Divider, IconButton, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import R314CallToActionsTableComponent from "./R314CallToActionsTableComponent";
import FilterIcon from "mdi-material-ui/FilterOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import EditTableRecord from "../../../components/EditDeleteTableRecord/EditTableRecord";
import { HttpRequest } from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

class F314CallToActionsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      showSearchBar: false,

      Data: [],

      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      isLoginMenu: false,
      isReload: false,
      eventDate: null,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isActive: 0,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({
      eventDate: date,
    });
  };

  getData = async () => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C314CommonCallToActionsView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      console.log("user  response", res);
      if (res.data != null && res.data.length > 0) {
        console.log(" res.DATA", res.data);

        // Add serial number and process data
        for (var i = 0; i < res.data.length; i++) {
          // Add serial number
          res.data[i].SRNo = i + 1;
          
          // Format boolean fields for better display

//isAvailableForAllLabel
        
         //res.data[i].isAvailableForAll = res.data[i].isAvailableForAll === "1" ? "All Users" : res.data[i].isAvailableForAll ==="0" ? "Specific User":"All Un-Registered Users";
        
          // res.data[i].isAvailableForAll="1"
           res.data[i].isAvailableForAll = res.data[i].isAvailableForAll === "1" ? "All Users" : res.data[i].isAvailableForAll ==="0" ? "Specific User":"All Un-Registered Users";
          
          // Ensure all fields have values or show empty string
             res.data[i].userLabel = res.data[i].userLabel || "";
          res.data[i].userLabel = res.data[i].userLabel || "";
          res.data[i].description = res.data[i].description || "";
          res.data[i].pageRouteLabel = res.data[i].pageRouteLabel || "";
          res.data[i].pageRoutePathLabel = res.data[i].pageRoutePathLabel || "";
          res.data[i].notificationTypeLabel = res.data[i].notificationTypeLabel || "";
          res.data[i].categoryLabel = res.data[i].categoryLabel || "";
          res.data[i].notificationMsg = res.data[i].notificationMsg || "";
          res.data[i].thumbnailFileName = res.data[i].thumbnailFileName || "";
          
          res.data[i].action = (
            <EditTableRecord
              recordId={res.data[i].id}
              // isActive={res.data[i].isActive}
              // handleChangeStatus={(recordId, isActive) =>
              //   this.handleChangeStatus(recordId, isActive)
              // }
              onEditURL={`#/F314CallToActionsForm/${res.data[i].id}`}
              handleOpenSnackbar={this.handleOpenSnackbar}
            />
          );
        }
        this.setState({
          Data: res.data || [],
        });
        console.log(" res.DATA AFTER", res.data);
      }
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  handleChangeStatus = async (recordId, isActive) => {
    const data = new FormData();
    data.append("id", recordId);
    data.append("isActive", isActive);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C300VoucherActiveStatusUpdate`,
      data,
      "authorize"
    );
    console.log(res);
    if (res.isSuccess) {
      this.handleSnackbar(true, "Status Changed", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  componentDidMount() {
    this.getData();
  }

  render() {
    // Updated columns with proper configuration
    const columns = [
      { name: "SRNo", title: "SR#" },
      { name: "label", title: "Label" },
      { name: "isAvailableForAllLabel", title: "Availability" },
      { name: "userLabel", title: "User" },
      { name: "description", title: "Description" },
      { name: "pageRouteLabel", title: "Page Route" },
      { name: "pageRoutePathLabel", title: "Route Path" },
      { name: "notificationTypeLabel", title: "Notification Type" },
      { name: "categoryLabel", title: "Category" },
      { name: "notificationMsg", title: "Notification Message" },
      { name: "thumbnailFileName", title: "File Name" },
      { name: "action", title: "Action" },
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
            width: '100%',
            overflowX: 'auto', // Allow horizontal scrolling if needed
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 16,
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Call To Actions Report
            </Typography>
            
            <div style={{ float: "right" }}>
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                >
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
              marginBottom: 16,
            }}
          />

          {this.state.Data && this.state.Data.length > 0 ? (
            <div style={{ width: '100%', overflowX: 'auto' }}>
              <R314CallToActionsTableComponent
                data={this.state.Data}
                columns={columns}
                showFilter={this.state.showTableFilter}
              />
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: 20 }}>
              <Typography variant="body1">No data available</Typography>
            </div>
          )}
          
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}

export default F314CallToActionsReport;